import React, { useState } from 'react';

const CouponHeader = ({ couponList }) => {
  const [copied, setCopied] = useState(false);
  const coupon = couponList?.[0];
  const code = coupon?.code;

  const handleCopy = async () => {
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      if (navigator.vibrate) navigator.vibrate(50);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div className="coupon-header">
      <span className="coupon-text">
        Offer at checkout. Apply <span className='code-name'>{code}</span>
        <button 
          className={`copy-btn ${copied ? 'is-copied' : ''}`} 
          onClick={handleCopy}
        >
          Copy code
          <span className="tooltip">{copied ? 'Copied!' : 'Copy'}</span>
        </button>
      </span>
    </div>
  );
};


export default CouponHeader;